//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';

angular.module('curalate').filter('countryNameToISO2', ['CountriesByName',
  (CountriesByName) => ((name) => CountriesByName[name] ? CountriesByName[name].twoDigitCode : name),
]);

angular.module('curalate').filter('countryISO2ToName', ['CountriesByISO2',
  (CountriesByISO2) => ((iso2) => CountriesByISO2[iso2] ? CountriesByISO2[iso2].name : iso2),
]);
